import { createSvgIcon } from "@material-ui/core";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 -960 960 960",
  children: /*#__PURE__*/_jsx("path", {
    d: "M840-480 671-241q-13 18-31 29.5T600-200H180q-24.75 0-42.375-17.625T120-260v-440q0-24.75 17.625-42.375T180-760h420q22 0 40 11.5t31 29.5l169 239Zm-75 0L611-700H180v440h431l154-220Zm-585 0v220-440 220Z"
  })
}), "Label");